import React from 'react';
import AudioPlayer from './AudioPlayer';
import theme from '../theme';

function MediaMessage({ msg, isMe, formatTime }) {
  const mediaData = msg.offer_data || {};
  const { url, media_type, file_name } = mediaData;

  if (!url) {
    return (
      <div style={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start', marginBottom: 8 }}>
        <div style={{
          maxWidth: '75%',
          padding: '10px 14px',
          borderRadius: isMe ? theme.bubble.mine : theme.bubble.theirs,
          background: isMe ? theme.colors.primary : theme.colors.white,
          color: isMe ? theme.colors.white : theme.colors.textMuted,
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          fontSize: theme.font.size.base,
        }}>
          Media non disponibile
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start', marginBottom: 8 }}>
      <div style={{
        maxWidth: '75%',
        borderRadius: isMe ? theme.bubble.mine : theme.bubble.theirs,
        background: isMe ? theme.colors.primary : theme.colors.white,
        overflow: 'hidden',
        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
      }}>

        {media_type === 'image' && (
          <img
            src={url}
            alt="foto"
            style={{ width: '100%', maxWidth: 220, display: 'block', cursor: 'pointer' }}
            onClick={() => window.open(url, '_blank')}
            onError={e => { e.target.style.display = 'none'; }}
          />
        )}

        {media_type === 'video' && (
          <video
            src={url}
            controls
            playsInline
            style={{ width: '100%', maxWidth: 220, display: 'block' }}
          />
        )}

        {media_type === 'audio' && (
          <div style={{ padding: '10px 14px' }}>
            <AudioPlayer url={url} isMe={isMe} />
          </div>
        )}

        {media_type === 'document' && (
          <div style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: theme.spacing.sm }}>
            <span style={{ fontSize: 24, flexShrink: 0 }}>📄</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: theme.font.size.base,
                fontWeight: 600,
                color: isMe ? theme.colors.white : theme.colors.textPrimary,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                marginBottom: 2,
              }}>
                {file_name || 'Documento'}
              </div>
              <a href={url} target="_blank" rel="noopener noreferrer" style={{ fontSize: theme.font.size.xs, color: isMe ? 'rgba(255,255,255,0.8)' : theme.colors.primary }}>Apri documento</a>
            </div>
          </div>
        )}

        {!['image', 'video', 'audio', 'document'].includes(media_type) && (
          <div style={{ padding: '10px 14px', fontSize: theme.font.size.base, color: isMe ? theme.colors.white : theme.colors.textMuted }}>
            File non supportato
          </div>
        )}

        <div style={{
          padding: '2px 10px 6px',
          fontSize: 10,
          opacity: 0.7,
          textAlign: 'right',
          color: isMe ? theme.colors.white : theme.colors.textMuted,
        }}>
          {formatTime(msg.created_at)}
          {isMe && <span style={{ marginLeft: 4 }}>{msg.read ? '✓✓' : '✓'}</span>}
        </div>

      </div>
    </div>
  );
}

export default MediaMessage;